<template>
    <!-- 发布渠道[[ -->
    <div class="publish" v-show="showPublish">
        <div class="header">
            <i class="ico-writing ico-step2"></i>
            <div class="tag">发布渠道</div>
        </div>
        <div class="edit-content">
            <div class="channel-group">
                <div class="channel-left-con f-inlineblock-top" :class="{'show-all': showAll}">
                    <div class="channel-item" v-for="(item,index) in mediaList" :key="item.enName"
                        @click.stop="selectMedia(item)">
                        <div class="channel-icon-block personal" :class="{'overduce': item.curAccount.expire == 1}">
                            <!-- 点击未过期的第一方渠道图标，加上边框及右上角出现钩子角标 -->
                            <div class="channel-icon" :class="{'channel-icon-border': selectMediaEnNameList.indexOf(item.enName)!=-1}"></div>

                            <img class="channel-img" :src="item.logo" :alt="item.name">
                            <i class="ico-writing ico-account-confirm" v-show="selectMediaEnNameList.indexOf(item.enName)!=-1"></i>
                            <i class="ico-writing ico-account-warn" v-if="item.curAccount.expire == 1"></i>
                            <div class="overdue-date-tooltip" v-if="item.curAccount.expire == 1">已过期</div>
                        </div>
                        <div class="channel-name">{{item.name}}</div>
                        <div class="channel-subname">
                            <div class="channel-subname-text">
                                {{item.curAccount.accountName}}
                            </div>
                            <i class="ico-writing account-btn" :class="[item.show ? 'ico-account-drap-up' : 'ico-account-drap-down']"
                                @click.stop="showDropdown(item,index)"></i>
                            <!-- 点击显示下拉框 -->
                            <div class="g-tooltip channel-selector" v-show="item.show">
                                <div class="g-tooltip-arrows-up"></div>
                                <div class="selector-content g-scrollbar">
                                    <div class="selector-item" :class="{'fail-status': accountItem.expire == 1}"
                                        v-for="accountItem in item.account" :key="accountItem.id" @click.stop="selectAccount(index,accountItem,item)">
                                        <img class="select-icon" :src="accountItem.accountHeader" :alt="accountItem.accountName">
                                        <i class="ico-writing ico-fail" v-if="accountItem.expire"></i>
                                        <span class="selector-item-name" :class="{'fail-tips-name': accountItem.expire}"
                                            :title="accountItem.accountName">{{accountItem.accountName}}</span>
                                        <span class="fail-tips" v-if="accountItem.expire">授权已失败</span>
                                    </div>
                                    <div class="selector-cancel" @click.stop="showDropdown(item,index)">取消</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="channel-item" v-for="item in noBindMediaList" :key="item.enName" @click="BindMediaIframe(item)">
                        <div class="channel-icon-block">
                            <div class="channel-icon"></div>
                            <!-- 第三方渠道，点击会出现登陆弹窗 -->
                            <img class="channel-img" style="filter: grayscale(100%)" :src="item.logo" :alt="item.name">
                        </div>
                        <div class="channel-name">{{item.name}}</div>
                    </div>
                    <!-- 点击展示更多发布渠道选项【【 -->
                    <div class="channel-item channel-more-btn js-more-btn" v-show="mediaList.length+noBindMediaList.length>6"
                        @click="showAll = !showAll">
                        <div class="channel-icon-block channel-btn">
                            <img v-if="!showAll" class="channel-icon more-platform" src="~Assets/img/pages/v4/icon-more-platform.png"
                                alt="更多平台">
                            <img v-if="showAll" class="channel-icon more-platform-active" src="~Assets/img/pages/v4/icon-more-platform-active.png"
                                alt="更多平台">
                        </div>
                        <div class="channel-name color-theme">更多平台</div>
                    </div>
                </div>
            </div>
            <!-- 显示或隐藏个性编辑区域内容 -->
            <div class="personal-edit">
                <div class="personal-edit-header">
                    <span class="auto-auth" @click="autoEditor" v-show="autoAuth">个性编辑</span>
                    <span class="auto-auth" @click="autoEditor" v-show="!autoAuth">智能编辑</span>
                    <i @click="autoEditor" class="ico-writing ico-drap-down" v-show="autoAuth"></i>
                    <i @click="autoEditor" class="ico-writing ico-drap-up" v-show="!autoAuth"></i>
                </div>
                <!-- 7.5修改 -->
                <ul class="personal-edit-content" v-show="!autoAuth">
                    <!-- 选中的媒体发布渠道 -->
                    <li class="f-clearfix pec-list" v-for="item in selectMediaList" :key="item.enName">
                        <div class="img-upload">
                            <tgl-image-cloud-upload class="hide-add-icon" v-if="!autoAuth" style="display: inline-block"
                                :btnId="item.enName" :isCrop="true" :domWidth="207" :ref="'imgUpload'+item.enName"
                                @completed="imageUploadCompleted" :choiceType="item">
                                <template #text>
                                    <div class="upload-text">点击上传封面图片</div>
                                    <div class="upload-text">不传显示文章统一封面</div>
                                </template>
                                <template #footer>
                                    <div style="font-size: 14px;">{{item.name}}</div>
                                </template>
                            </tgl-image-cloud-upload>
                            <!-- <div class="size-advice f-hide-col-1">建议尺寸：300*200</div> -->
                        </div>
                        <div class="text-block">
                            <div class="title">
                                <input class="title-textarea" rows="1" maxlength="30" v-model="item.title"
                                    placeholder="请输入内容标题（30个字以内）">
                            </div>
                            <div class="introduction">
                                <textarea v-model="item.summary" class="introduction-textarea" maxlength="200"
                                    placeholder="填写简介（10-50个字符）"></textarea>
                            </div>
                        </div>
                    </li>

                </ul>
            </div>
        </div>
        <!-- 第三方弹窗[[ -->
        <bind-media ref="mediaRef" @bindResult="loadMedia"></bind-media>
        <!-- 第三方弹窗]] -->
    </div>
</template>
<script>
import imgUpload from 'Components/v4/upload/imgUpload_v4';
import bindMedia from 'Components/v4/pop/bind_media.vue';
import {
    MediaUserAccountGroup, MediaList, ActivityInfo, TaskBrief
} from 'Services/getData';

export default {
    props: {
        demandType: {
            type: String,
            required: true
        },
        mediaInfo: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    data() {
        return {
            showAll: false,
            tabList: [
                {
                    name: '图文内容',
                    val: 0
                },
                {
                    name: '视频内容',
                    val: 1
                }
            ],
            curTab: '',
            showPublish: false,
            asyncmedia: [],
            mediaList: [],
            mediaAll: [],
            noBindMediaList: [],
            selectMediaList: [],
            autoAuth: true, //智能编目开关
            mediaChangeNum: 0,
            activityParams: {
                missionId: '',
                demandType: ''
            },
            activityInfo: {},
            interval: ''
        }
    },
    computed: {
        selectMediaEnNameList() {
            let list = [];
            this.selectMediaList.forEach((v, k) => {
                list.push(v.enName)
            })
            return list;
        }
    },
    components: {
        imgUpload,
        bindMedia
    },
    created() {
        this.activityParams.missionId = this.$route.params.taskId;
        this.activityParams.demandType = this.demandType;
        this.getActivityInfo();
    },
    mounted() {
        this.$nextTick(() => {
            this.mediaChange();
        })
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    methods: {
        saveDefaultMedia() {
            if (!this.showPublish) {
                return;
            }
            if (this.selectMediaList.length) {
                let defaultMedia = []
                this.selectMediaList.forEach((v, k) => {
                    let mediaInfo = {};
                    // debugger
                    mediaInfo.accountId = v.curAccount.id;
                    defaultMedia.push(mediaInfo);
                })
                localStorage.setItem('defaultMedia', JSON.stringify(defaultMedia))
            }
        },
        getDefaultMedia() {
            setTimeout(() => {
                if (localStorage.getItem('defaultMedia') && this.showPublish) {
                    let selectMediaList = JSON.parse(localStorage.getItem('defaultMedia'));
                    selectMediaList.forEach((v, k) => {
                        this.$nextTick(() => {
                            this.asyncmedia.forEach((j, i) => {
                                j.account.forEach((j2, i2) => {
                                    if (j2.id == v.accountId && !j2.expire) {
                                        j.curAccount = j2;
                                        this.selectMediaList.push(j);
                                    }
                                });
                            });
                        });
                    });
                }
            }, 2000)

        },
        async editDraft() {
            // let res = await DraftDetail({draftId: this.$route.query.draftId});
            // let res = await DraftDetail(this.$route.query.draftId);
            // let data = res.data.data;

            // this.mediaList = [];
            if (this.mediaInfo) {
                let selectMediaList = this.mediaInfo;
                selectMediaList.forEach((v, k) => {
                    if (v.outTitle || v.outCover || v.outDesc) {
                        this.autoAuth = false;
                    }
                    this.$nextTick(() => {
                        this.asyncmedia.forEach((j, i) => {
                            j.account.forEach((j2, i2) => {
                                if (j2.id == v.accountId) {
                                    j.curAccount = j2;
                                    j.title = v.outTitle;
                                    j.cover = v.outCover;
                                    j.summary = v.outDesc;
                                    this.selectMediaList.push(j)
                                }
                            })
                        })
                    })
                })
            }
            console.log(this.selectMediaList)
            if (this.demandType == 0) {
                this.curTab = 0;
                // this.$refs.picCnt.getDraft(data,this.autoAuth);
            } else {
                this.curTab = 1;
                // this.showPublish = true;
                // this.$refs.videoCnt.hasVideo = true;
                // this.$refs.videoCnt.getDraft(data,this.autoAuth);
            }
        },
        getSelectMediaList() {
            return {
                mediaInfo: this.selectMediaList,
                autoAuth: this.autoAuth
            };
        },
        async getMediaList() {
            let res = await MediaList();
            if (res.data.code == 0) {
                this.mediaAll = res.data.data;
            }
        },
        async getActivityInfo() {
            MediaList().then(async (ret) => {
                if (ret.data.code == 0) {
                    this.mediaAll = ret.data.data;
                }
                let res = await TaskBrief(this.activityParams);
                if (res.data.code == 0) {
                    this.activityInfo = res.data.data;
                    if (this.activityInfo.account_type) {
                        this.showPublish = true;
                    }
                }
                this.mediaAll = this.mediaAll.filter(item => !!res.data.data.medias[item.enName]);
                this.loadMedia();
            })
            console.log(this.mediaAll)
        },
        mediaChange() {
            this.interval = setInterval(() => {
                if (this.$common.getSessionStore('mediaChange') == this.mediaChangeNum) {
                    return;
                } else {
                    this.mediaChangeNum = this.$common.getSessionStore('mediaChange');
                }
            }, 1000)
        },
        imageUploadCompleted(res) {
            this.selectMediaList.forEach((v, k) => {
                if (v.enName == res.btnId) {
                    v.cover = res.url;
                }
            });
        },
        selectMedia(item, from) {
            if (item.curAccount.expire == 1) {
                this.$confirm('账号授权已过期,是否前往媒体账号重新绑定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$router.push({
                        name: 'v4-manage-account'
                    })
                }).catch(() => {

                });
            } else {
                // 媒体选择
                let exist = -1;
                if (this.selectMediaList) {
                    this.selectMediaList.forEach((v, k) => {
                        if (v.enName == item.enName) {
                            exist = k;
                        }
                    })
                }
                if (exist == -1) {
                    item.cover = '';
                    item.title = '';
                    item.summary = '';
                    this.selectMediaList.push(item);
                } else {
                    if (!from) {
                        this.selectMediaList.splice(exist, 1);
                    }
                }
            }
        },
        selectAccount(index, accountItem, item) {
            // 账号选择
            if (accountItem.expire == 1) {
                this.$confirm('账号授权已过期,是否前往媒体账号重新绑定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$router.push({
                        name: 'v4-manage-account'
                    })
                }).catch(() => {

                });
            } else {
                let list = this.mediaList;
                this.mediaList = '';
                list[index].curAccount = accountItem;
                list[index].show = false;
                this.mediaList = list;
                this.selectMedia(item, 'selectAccount');
            }
        },
        async getDraft() {
            // let res = await DraftDetail({draftId: this.$route.query.draftId});
            let res = await DraftDetail(this.$route.query.draftId);
            let data = res.data.data;

            // this.mediaList = [];
            if (data.content.mediaInfo) {
                let selectMediaList = JSON.parse(data.content.mediaInfo)
                selectMediaList.forEach((v, k) => {
                    if (v.title || v.cover || v.summary) {
                        this.autoAuth = false;
                    }
                    this.$nextTick(() => {

                        this.asyncmedia.forEach((j, i) => {
                            j.account.forEach((j2, i2) => {
                                if (j2.id == v.accountId) {
                                    j.curAccount = j2;
                                    j.title = v.title;
                                    j.cover = v.cover;
                                    j.summary = v.summary;
                                    this.selectMediaList.push(j)
                                }
                            })
                        })
                    })
                })
            } else {
                this.getDefaultMedia();
            }
            console.log(this.selectMediaList)
            if (data.articleType == 0) {
                this.curTab = 0;
                this.$refs.picCnt.getDraft(data, this.autoAuth);
            } else {
                this.curTab = 1;
                this.showPublish = true;
                this.$refs.videoCnt.hasVideo = true;
                this.$refs.videoCnt.getDraft(data, this.autoAuth);
            }
        },
        changeTab(index = 0) {
            // if(this.curTab !== index){
            //     this.curTab = index;
            //     this.autoAuth = true;
            //     this.selectMediaList = [];
            //     this.showPublish = (index == 0 ? true : false);
            //     this.$refs.videoCnt.hasVideo = false;
            //     this.$refs.videoCnt.delVideoFile();
            // }
            this.filterMedia();
        },
        filterMedia() {
            // 媒体渠道筛选
            this.noBindMediaList = [...this.mediaAll];
            let mediaEnNameAll = [];
            this.mediaAll.forEach((v, k) => {
                mediaEnNameAll.push(v.enName);
            })
            this.mediaList = [];
            if (this.demandType == 0) {
                this.asyncmedia.forEach((v, k) => {
                    if ((mediaEnNameAll.indexOf(v.enName) != -1) && (v.enName != 'iqiyi') && (v.enName != 'youku')) {
                        this.mediaList.push(v);
                    }
                    v.show = false;
                    v.curAccount = v.account[0];
                    for (let i = 0; i < this.noBindMediaList.length; i++) {
                        if ((v.enName == this.noBindMediaList[i].enName) || this.noBindMediaList[i].enName == 'iqiyi' || this.noBindMediaList[i].enName == 'youku') {
                            this.noBindMediaList.splice(i, 1);
                            --i;
                        }
                    }
                })
            } else {
                this.asyncmedia.forEach((v, k) => {
                    if (mediaEnNameAll.indexOf(v.enName) != -1) {
                        this.mediaList.push(v);
                    }
                    v.show = false;
                    v.curAccount = v.account[0];
                    this.noBindMediaList.forEach((b, i) => {
                        if (v.enName == b.enName) {
                            this.noBindMediaList.splice(i, 1);
                        }
                    })
                })
            }
            if (this.$route.params.articleId) {
                this.editDraft();
            }
        },
        async loadMedia() {
            let res = await MediaUserAccountGroup();
            if (res.data.code == 0) {
                this.asyncmedia = res.data.data;
            }
            this.changeTab(this.curTab);
        },
        showDropdown(item, index) {
            let status = item.show;
            let list = this.mediaList;
            this.mediaList = '';
            list.forEach((v, k) => {
                v.show = false;
            })
            list[index].show = !status;
            this.mediaList = list;
            console.log('drop')
        },
        saveDraft() {
            if (this.curTab == 0) {
                this.$refs.picCnt.saveDraft(this.selectMediaList, this.autoAuth);
            }
            if (this.curTab == 1) {
                this.$refs.videoCnt.saveDraft(this.selectMediaList, this.autoAuth);
            }
        },
        publish() {
            if (this.curTab == 0) {
                this.$refs.picCnt.publish(this.selectMediaList, this.autoAuth);
            }
            if (this.curTab == 1) {
                this.$refs.videoCnt.publish(this.selectMediaList, this.autoAuth);
            }

        },
        resetPage() {
            this.autoAuth = true;
            this.selectMediaList = [];
            // if(this.curTab == 0){
            this.$refs.picCnt.resetPage();
            // }
            // if(this.curTab == 1){
            //     this.$refs.videoCnt.resetPage();
            // }
        },
        cancel() {
            this.$confirm('系统可能不会保存您所做的更改', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            })
                .then(() => {
                    // this.saveDraft();
                    this.resetPage();
                })
                .catch(action => {

                });
        },
        showPreview() {
            // if(this.curTab == 0){
            this.$refs.picCnt.showPreview();
            // }
            // if(this.curTab == 1){
            //     this.$refs.videoCnt.showPreview();
            // }
        },
        async BindMediaIframe(media) {
            this.$refs.mediaRef.BindMediaIframe(media);
        },
        autoEditor() {
            if (this.autoAuth) {
                this.$confirm('在个性编目状态下。标题和封面图的修改只会同步到对应的渠道', '确认开启个性编辑？', {
                    'confirmButtonText': '确认', cancelButtonText: '取消'
                })
                    .then(() => {
                        this.autoAuth = false;
                    }).catch(() => { });
            } else {
                this.$confirm('在智能编目状态下。标题和封面图的修改会同步到对应的渠道', '确认开启智能编辑？', {
                    'confirmButtonText': '确认', cancelButtonText: '取消'
                })
                    .then(() => {
                        this.autoAuth = true;
                    }).catch(() => { });
            }
        },
        getTitleCover(title, cover, summary = '') {
            this.selectMediaList.forEach((v, k) => {
                v.title = title;
                v.cover = cover;
                v.summary = summary;
            })
        }
    },
    watch: {
        showPublish(cur, old) {
            // if(this.activityInfo.account_type){
            //     this.showPublish = true;
            // }else{
            //     this.showPublish = false;
            // }
        },
        autoAuth(val, oldval) {
            if (oldval) {
                // 切换成个性编辑时，同步标题和cover
                this.$emit('changeAuth');
            }

        },
        mediaChangeNum(val) {
            this.loadMedia();
        }
    }
}
</script>
<style lang="scss" scoped>
@charset "utf-8";
@import '~Assets/sass/pages/v4/common/_config_theme.scss';
@import '~Assets/sass/pages/v4/contribute/_contribute_icon.scss';
// 发布
.publish {
    width: 100%;
    position: relative;
    background-color: $color-bg;
    margin-top: 30px;
    padding-top: 30px;
    .auto-auth {
        cursor: pointer;
    }
    .pec-list {
        padding-bottom: 47px;
    }
    //头部
    .header {
        position: relative;
        .tag {
            color: $color-theme;
            margin-bottom: 31px;
            padding: 0 30px;
        }
        .ico-step1,
        .ico-step2 {
            position: absolute;
            left: -10px;
            top: -8px;
        }
    }
    .edit-content {
        padding: 0 30px;
        overflow: hidden;
        //7.3修改
        //			padding-bottom: 79px;
        .channel-group {
            font-size: 0;
            border-bottom: 1px solid $color-border2;
            .channel-item {
                display: inline-block;
                width: 72px;
                height: 72px;
                vertical-align: top;
                margin-right: 65px;
                margin-bottom: 100px;
                text-align: center;
                color: $color-gray;
                font-size: $middle-font;
                //7.3修改   此注释样式删除
                //					&:nth-child(7n) {
                //						margin-right: 0;
                //					}
                .channel-icon-border {
                    border: 3px solid $color-theme;
                }
                .channel-icon-block {
                    position: relative;
                    display: inline-block;
                    vertical-align: top;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    cursor: pointer;
                    .channel-icon {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        border-radius: 100%;
                        box-sizing: border-box;
                    }
                    .channel-img {
                        width: 70px;
                        height: 70px;
                        margin: 1px;
                        border-radius: 100%;
                    }

                    .ico-account-confirm,
                    .ico-account-warn {
                        position: absolute;
                        top: 0;
                        right: 5px;
                    }
                    .overdue-date-tooltip {
                        position: absolute;
                        bottom: -10px;
                        left: 0;
                        right: 0;
                        margin: auto;
                        width: 50px;
                        display: none;
                        background-color: $color-theme;
                        color: $color-bg;
                        &::before {
                            position: absolute;
                            top: -5px;
                            left: 0;
                            right: 0;
                            margin: auto;
                            display: inline-block;
                            content: '';
                            width: 0;
                            height: 0;
                            border-style: solid;
                            border-width: 0 5px 5px 5px;
                            border-color: transparent transparent $color-theme
                                transparent;
                        }
                    }
                    &:hover {
                        .overdue-date-tooltip {
                            display: block;
                        }
                    }
                }
                .channel-name {
                    margin-top: 11px;
                }
                .more-platform-name {
                    color: $color-theme;
                }
                .channel-subname {
                    position: relative;
                    .channel-subname-text {
                        width: 70px;
                        max-height: 40px;
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    .ico-account-drap-down,
                    .ico-account-drap-up {
                        position: absolute;
                        cursor: pointer;
                        top: 0;
                        right: -25px;
                    }
                    .channel-selector {
                        position: absolute;
                        left: -8px;
                        top: 32.7px;
                        .selector-content {
                            width: 192px;
                            max-height: 228px;
                            border: 1px solid $color-border1;
                            box-sizing: border-box;
                            box-shadow: 0 0 10px 0 rgba(214, 214, 214, 0.5);
                            border-radius: 2px;
                            .fail-status {
                                .select-icon {
                                    border: 2px solid #e64340;
                                }
                                .item-name {
                                    color: $color-text;
                                    width: 78px;
                                }
                                .fail-tips {
                                    font-size: $small-font;
                                    color: #e64340;
                                }
                            }
                            .selector-item {
                                position: relative;
                                text-align: left;
                                cursor: pointer;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                height: 39px;
                                line-height: 39px;
                                box-sizing: border-box;
                                padding: 0 10px;
                                &:hover {
                                    background-color: #f5f5f5;
                                }
                                .select-icon {
                                    width: 25px;
                                    height: 25px;
                                    vertical-align: middle;
                                    border-radius: 50%;
                                    box-sizing: border-box;
                                }
                            }
                            .selector-cancel {
                                cursor: pointer;
                                padding: 6px 0;
                                border-top: 1px solid $color-border1;
                                text-align: center;
                            }
                        }
                        .ico-fail {
                            position: absolute;
                            top: 8px;
                            left: 27px;
                        }
                    }
                }
            }
            .channel-btn {
                cursor: pointer;
                color: $color-theme;
            }
            //7.3修改
            .channel-more-btn {
                margin: 0;
            }
        }
        .personal-edit-header {
            padding: 30px 0;
            color: $color-theme;
            text-align: center;
            .ico-drap-up,
            .ico-drap-down {
                vertical-align: middle;
                margin-left: 15px;
                cursor: pointer;
            }
        }
        .personal-edit-content {
            //7.11修改
            //				padding-bottom: 125px;
            overflow: hidden;
        }
        .img-upload {
            float: left;
            .ico-video-upload {
                margin-top: 11px;
            }
            .size-advice {
                width: 207px;
                margin-top: 11px;
                color: $color-gray;
            }
        }
        .text-block {
            float: left;
            width: calc(100% - 237px);
            margin-left: 30px;
            font-size: $middle-font;
            .title {
                .title-textarea {
                    display: inline-block;
                    width: 100%;
                    height: 20px;
                    padding-bottom: 10px;
                    border: 0;
                    font-size: 14px;
                    color: $color-gray;
                    border-bottom: 1px solid $color-border1;
                    &:active,
                    &:focus {
                        border-bottom: 1px solid $color-theme;
                    }
                }
            }
            .introduction {
                .introduction-textarea {
                    display: inline-block;
                    width: 100%;
                    height: 157px;
                    border: 0;
                    padding: 10px 0;
                    color: $color-gray;
                    border-bottom: 1px solid $color-border1;
                    &:active,
                    &:focus {
                        border-bottom: 1px solid $color-theme;
                    }
                }
            }
            .tag {
                .tag-textarea {
                    width: 100%;
                    padding-top: 20px;
                    padding-bottom: 10px;
                    border: 0;
                    border-bottom: 1px solid $color-border1;
                    color: $color-gray;
                    &:active,
                    &:focus {
                        border-bottom: 1px solid $color-theme;
                    }
                }
            }
            .classify {
                position: relative;
                width: 100%;
                border-bottom: 1px solid $color-border1;
                .classify-name {
                    width: 100%;
                    padding-top: 20px;
                    padding-bottom: 10px;
                    border: 0;
                    cursor: pointer;
                }
                .ico-drap-up,
                .ico-drap-down {
                    position: absolute;
                    right: -2px;
                    top: 15px;
                    cursor: pointer;
                }
                .g-selector-option {
                    width: 100%;
                    .selector {
                        width: 100%;
                        height: 165px;
                        border: 1px solid $color-border1;
                        .select-item {
                            color: $color-gray;
                        }
                    }
                }
            }
        }
    }
}
</style>
